import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppService } from './AppService.class';

@Injectable({
  providedIn: 'root'
})
export class ReportsManagerService extends AppService<any> {

  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "reports_manager";
   }
   public getReportsData(data:any){
    let tmp = this.appmod;
    this.appmod = "custom/reports_manager";
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
   }

}